var countdown = function countdown() {
  var countdownEl = document.getElementById('countdown-js');
  if (!countdownEl) {
    return;
  }
  var date = countdownEl.dataset.date;
  var countDownDate = new Date(date);

  // Update the count down every 1 second
  var x = setInterval(function () {
    var now = new Date();
    var distance = countDownDate - now;
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    var minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
    var seconds = Math.floor(distance % (1000 * 60) / 1000);
    countdownEl.querySelector('#countdown-js-days').innerHTML = (days < 10 ? '0' : '') + days;
    countdownEl.querySelector('#countdown-js-hours').innerHTML = (hours < 10 ? '0' : '') + hours;
    countdownEl.querySelector('#countdown-js-min').innerHTML = (minutes < 10 ? '0' : '') + minutes;
    countdownEl.querySelector('#countdown-js-sec').innerHTML = (seconds < 10 ? '0' : '') + seconds;
    if (distance < 0) {
      clearInterval(x);
    }
  }, 1000);
};
export { countdown };